import type { ReactNode } from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/shared/components/ui/skeleton'
import type { LucideIcon } from 'lucide-react'

interface MetricaCardProps {
  title: string
  value: string | number
  icon: LucideIcon
  color?: 'violet' | 'green' | 'blue' | 'purple'
  isLoading?: boolean
  footer?: ReactNode
}

const colorMap = {
  violet: 'text-violet-600 bg-violet-50',
  green: 'text-green-600 bg-green-50',
  blue: 'text-blue-600 bg-blue-50',
  purple: 'text-purple-600 bg-purple-50',
}

export function MetricaCard({ title, value, icon: Icon, color = 'violet', isLoading, footer }: MetricaCardProps) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">{title}</CardTitle>
        <div className={`rounded-full p-2 ${colorMap[color]}`}>
          <Icon className="h-4 w-4" />
        </div>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <Skeleton className="h-8 w-24" />
        ) : (
          <>
            <div className="text-2xl font-bold">{value}</div>
            {footer}
          </>
        )}
      </CardContent>
    </Card>
  )
}
